import css from './CatBox.css';
import {MrSneeki} from "../MrSneeki/MrSneeki";
import {wait} from "../utils";
import {Eyes} from "./Eyes";
import {explode} from "@ddlab/bomb";

export class CatBox {
    constructor() {
        this._boxEl = document.createElement('button');
        this._boxEl.addEventListener('click', this._handleClick.bind(this));
        this._boxEl.className = css.box;

        this._eyes = new Eyes(this._boxEl);

        const boxTextEl = document.createElement('p');
        boxTextEl.className = css.text;
        boxTextEl.innerHTML = 'dom\'t click';
        this._boxEl.appendChild(boxTextEl);
        this._containerEl = document.createElement('div');
        this._containerEl.className = css.container;
        this._containerEl.appendChild(this._boxEl);
        document.body.appendChild(this._containerEl);
    }

    onAfterCatDrop(cb) {
        this._afterCatDropHandler = cb;
    }

    explode() {
        this._containerEl.setAttribute('style', 'opacity: 0;');

        explode(this._boxEl, {
            color: '#927d6b', 
            distance: 10,
            duration: 1500
        });

        explode(this._boxEl, {
            shatterClass: css.catShatter,
            distance: 20,
            duration: 1000,
            sliceCount: 5,
            maxSliceSize: 100
        });
        
        explode(this._boxEl, {
            color: 'yellow', 
            distance: 10,
            duration: 500
        });
    }

    disable() {
        this._isDisabled = true;
    }

    _handleClick() {
        if (this._isDisabled) {
            return;
        }
        clearTimeout(this._lastTimeOutRef);
        this._boxEl.focus();
        this._eyes.hide();
        this._createFallingCat();
        this._lastTimeOutRef = setTimeout(() => {
            this._boxEl.blur();
            this._eyes.show();
        }, 500);
    }

    async _createFallingCat() {
        const fallingMrSneeki = new MrSneeki(false, this._containerEl, css.cat);
        const initialAngle = Math.random() * 360;
        fallingMrSneeki.getContainerEl().style = `transform: translateY(0) rotate(${initialAngle}deg)`;

        await wait(30);
        requestAnimationFrame(() =>
            fallingMrSneeki.getContainerEl().style = `transform: translateY(100vh) rotate(${initialAngle + 90}deg)`
        );

        await wait(500);
        this._afterCatDropHandler && this._afterCatDropHandler();
        fallingMrSneeki.vanish();
    }
}
